import { styled } from "@mui/system";
import { Grid } from "@mui/material";

export default styled(Grid)(({
    minHeight: "100vh",
}));
